<!-- Hero Section Start -->
<script src="assets/js/main.js"></script>

<div class="container-fluid">
    <ngx-slick-carousel class="carousel homebnr" #slickModal="slick-carousel" [config]="slideConfig"
        (init)="slickInit()" (breakpoint)="breakpoint()" (afterChange)="afterChange()" (beforeChange)="beforeChange()">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
            <div class="bannerimg" style="background-image: url('{{ slide.img }}'); "></div>
            <div class="custom-box-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 bnrcontent" data-aos="fade-left">
                            <div class="bnrtxt">
                                <!-- <div class="bnrtxt" [ngClass]="slide.index == 2 ? 'font-style-diff' :''"> -->
                                <p class="bnrtitle desktoptitle" [innerHTML]="slide.title"></p>
                                <p class="bnrtitle mobiletitle text-left" [innerHTML]="slide.titlemobile"
                                    style="display: none;">
                                </p>
                                <p class="bnrtitle mobiletitle text-left" [innerHTML]="slide.descmobile"
                                    style="display: none;">
                                </p>
                                <p class="bnrdesc" [innerHTML]="slide.desc"></p>
                                <p class="bnrsubdesc" [innerHTML]="slide.subdesc"></p>
                            </div>
                            
                            <div class="bnrbtn">
                                
                                <a *ngIf="slide.button1 != ''" href="#" data-toggle="modal"
                                    data-target="#modalContactForm"
                                    class="btn contact-btn btn-rectengle text-white mr-4">{{slide.button1}}</a>
                                <a *ngIf="slide.index != 7 && slide.index != 2" [routerLink]="slide.link"
                                    class="btn contact-btn btn-rectengle text-white rightzero position-absolute">{{slide.button2}}</a>
                                <a *ngIf="slide.index == 7" [href]="slide.link" target="_blank"
                                    class="btn contact-btn btn-rectengle text-white rightzero position-absolute">{{slide.button2}}</a>
                                <a *ngIf="slide.index == 6" href="https://government.economictimes.indiatimes.com/news/secure-india/protectt-ai-wins-security-product-company-of-the-year-award/106218794?utm_source=whatsapp_web&utm_medium=social&utm_campaign=socialsharebuttons" target="_blank"
                                    class="btn contact-btn btn-rectengle text-white rightzero position-absolute">{{slide.button2}}</a>    
                            </div>
                     
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
</div>

<!-- Page Conttent -->
<main class="page-content">

    <div class="container">
        <div class="row mobilesecurity newcard mt-30 mb-30">
            <div class="col-md-5 d-none d-sm-block">
                <div class="image-container">
                    <img class="img-fluid hidden-xs visible-md" src="assets/images/new/mobile_security.webp"
                        alt="Mobile Security as a Service">
                </div>
            </div>
            <div class="col-md-7 contentcenter">
                <h4 class="text-center" style="font-size: 26px"><span class="redcontent" style="font-size: 26px">Mobile
                        Application Security</span>
                    Revolutionized</h4>
                <p class="mt-10">Protectt.ai offers an Innovative Mobile App Security platform to safeguard Mobile Apps
                    from ever-evolving mobile cyber threats & frauds. Protect your sensitive Mobile Apps with our
                    advanced Mobile App Security platform with Runtime Application Self Protection (RASP) capabilities
                    and Extended Detection and Response (XDR) features.</p>
                <p class="mt-10">Our Mobile App Security Platform provides real-time protection with greater agility,
                    faster go-to-market, scalable & easy deployment solution. Comply your mobile apps with global
                    regulatory compliances and ensure enhanced customer experience.</p>
                <p class="mt-10">Learn more about our game-changing Mobile App Security XDR Platform & get the best RASP
                    security for your Android and iOS mobile apps with automated Mobile Cyber Defense.</p>
                <div class="text-center d-block">
                    <img class="img-fluid hidden-md visible-xs imgpadding" src="assets/images/new/mobile_security.webp"
                        alt="mobile app security services">
                </div>
                <!-- <div class="row mt-35 pl-0 btncombo">
                    <div class="col-md-12 col-sm-12 col-xs-12 btnset">
                        <a class="btn-rectangle btn col-sm-4 col-xs-4 btn-size" href="#" data-toggle="modal"
                            data-target="#modalContactForm">Request Demo</a>
                        <a class="btn-rectangle ml-2 btn col-sm-4 col-xs-4 btn-size" href="#" data-toggle="modal"
                            data-target="#exampleModal">Product Factsheet</a>
                        <a class="btn-rectangle ml-2 btn col-sm-4 col-xs-4 btn-size"
                            href="mailto:sales@protectt.ai">Contact
                            Sales</a>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="row mobileapplication newcard mt-30">
            <div class="col-md-12 section-title text-center ">
                <h4>Mobile App Security Platform</h4>
            </div>
        </div>

        <!-- <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-md-6 order-md-6 text-center">
                    <div class="agency-thumb">
                        <div class="image-container">
                            <img style="width:100%" src="assets/images/home/appprotectt_home.webp"
                                alt="Secure your Mobile Apps with All in One Mobile App Security " />
                        </div>
                    </div>
                </div>
                <div class="col-md-6 order-md-1">
                    <div class="row align-items-center h-100">
                        <div class="col mt-3">
                            <h3><span class="textred" style="font-size: 26px;">App</span><span class="textblue"
                                    style="font-size: 26px;">Protectt</span></h3>
                            <div class="image-container-mobile text-center mt-3">
                                <img style="width:100%" src="assets/images/home/appprotectt_home.webp"
                                    alt="Secure your Mobile Apps with All in One Mobile App Security " />
                            </div>
                            <p class="text-justify">Comprehensive Mobile App Security platform with Runtime Application
                                Self Protection
                                (RASP) and powered by Deep Tech.
                                <br><br>AppProtectt provides 50+ Mobile App Security features such as protection from
                                rooted & malicious devices, unsecured network, advance protection from reverse
                                engineering & app tampering, unsecured Wi-Fi security check, protection from screen
                                mirroring and sharing, malware protection.
                                <br><br>AppProtectt enables Real Time Threat Dashboard, Security Configuration, and
                                advance security build on DevSecOpS. Aligns with the global regulatory compliances and
                                ensures a seamless mobile App Security for Android and iOS mobile apps.
                            </p>
                            <p><a routerLink="/appprotectt" class="btn btn-primary">Read More</a></p>
                        </div>
                    </div>


                </div>
            </div>
        </div> -->


        <div class="container-fluid">
            <!--  image right  -->
            <div class="row align-items-center">
                <div class="col-md-6 order-md-6 text-center">
                    <div class="agency-thumb">
                        <div class="image-container">
                            <img style="width:100%" src="assets/images/home/appprotectt_home.webp"
                                alt="Secure your Mobile Apps with All in One Mobile App Security " />
                        </div>
                    </div>
                </div>
                <!-- /.col-md-6 -->
                <div class="col-md-6 order-md-1">
                    <div class="row align-items-center h-100">
                        <div class="col mt-3">
                            <h3><span class="textred" style="font-size: 26px;">App</span><span class="textblue"
                                    style="font-size: 26px;">Protectt</span></h3>
                            <div class="image-container-mobile text-center mt-3">
                                <img style="width:100%" src="assets/images/home/appprotectt_home.webp"
                                    alt="Secure your Mobile Apps with All in One Mobile App Security " />
                            </div>
                            <p class="text-justify">Comprehensive Mobile App Security platform with Runtime Application
                                Self Protection
                                (RASP) and powered by Deep Tech.
                                <br><br>AppProtectt provides 50+ Mobile App Security features such as protection from
                                rooted & malicious devices, unsecured network, advance protection from reverse
                                engineering & app tampering, unsecured Wi-Fi security check, protection from screen
                                mirroring and sharing, malware protection.
                                <br><br>AppProtectt enables Real Time Threat Dashboard, Security Configuration, and
                                advance security build on DevSecOpS. Aligns with the global regulatory compliances and
                                ensures a seamless mobile App Security for Android and iOS mobile apps.
                            </p>
                            <p class="mobile-view"><a routerLink="/appprotectt" class="btn btn-primary">Read More</a>
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            <!--  image left  -->
            <div class="row align-items-center mt-30">
                <div class="col-md-6 text-center">
                    <div class="agency-thumb">
                        <div class="image-container">
                            <img style="width:100%" src="assets/images/home/appbind_home.webp"
                                alt="Mobile Application Security Assessment," />
                        </div>

                    </div>
                </div>

                <div class="col-md-6">
                    <div class="row align-items-center h-100">
                        <div class="col mt-3">
                            <h3><span class="textred" style="font-size: 26px;">App</span><span class="textblue"
                                    style="font-size: 26px;">Bind</span></h3>
                            <div class="image-container-mobile text-center mt-3">
                                <img style="width:100%" src="assets/images/home/appbind_home.webp"
                                    alt="Secure your Mobile Apps with All in One Mobile App Security " />
                            </div>
                            <p class="text-justify">Zero Trust DEVICE & SIM Binding for sensitive financial mobile apps.
                                <br><br>It is a single platform to orchestrate multiple touch points (Mobile App, API,
                                SMS Gateways) to build Unique Digital Identity of Mobile App users, available for
                                Android & iOS.
                                <br><br>AppBind prevents identity frauds executed through SIM swapping, SMS spoofing,
                                data from a stolen device, brute force attacks and social engineering. AppBind creates a
                                unique digital identity for every mobile app user. On the principles of Device & SIM
                                Binding, it validates the user’s Digital Identity with our zero-factor authentication on
                                every launch of Mobile App.
                                <br><br>AppBind is empowered with our cutting-edge proprietary technology for advanced
                                and adaptive defense against identity thefts and frauds.
                            </p>
                            <p class="mobile-view"><a routerLink="/appbind" class="btn btn-primary">Read More</a></p>

                        </div>
                    </div>
                </div>
            </div>

            <!--  image right  -->
            <div class="row align-items-center mt-30">
                <div class="col-md-6 order-md-6 text-center">

                    <div class="agency-thumb">
                        <div class="image-container">
                            <img style="width:100%" src="assets/images/home/codeprotectt_home.webp"
                                alt="Secure your Mobile Apps with All in One Mobile App Security " />
                        </div>
                    </div>
                </div>
                <!-- /.col-md-6 -->
                <div class="col-md-6 order-md-1">
                    <div class="row align-items-center h-100">
                        <div class="col mt-3">
                            <h3><span class="textred" style="font-size: 26px;">Code</span><span class="textblue"
                                    style="font-size: 26px;">Protectt</span></h3>
                            <div class="image-container-mobile text-center mt-3">
                                <img style="width:100%" src="assets/images/home/codeprotectt_home.webp"
                                    alt="Secure your Mobile Apps with All in One Mobile App Security " />
                            </div>
                            <p class="text-justify">Android & iOS code obfuscation – Extended protection against reverse
                                engineering & app
                                tampering.
                                <br><br>Obfuscate your Mobile App Codes in minutes with an easy-to-deploy CodeProtectt
                                solution for your sensitive Mobile Apps. It obfuscates Android code developed in Java,
                                Kotlin, Ionic, Native C, Objective C and JavaScript. CodeProtectt is an innovative logic
                                safeguards code from tampering by hackers & fraudsters. It protects code against common
                                cyber threats such as code injection, reverse engineering, and tampering.
                                <br><br>Harden your Mobile App Security with next-generation code obfuscation and
                                protect your apps against emerging cyber threats such as code injection, reverse
                                engineering, and tampering.
                            </p>
                            <p class="mobile-view"><a routerLink="/codeprotectt" class="btn btn-primary">Read More</a>
                            </p>
                        </div>
                    </div>

                </div>
            </div>



            <!--  image left  -->
            <div class="row align-items-center mt-30">


                <div class="col-md-6 text-center">
                    <div class="agency-thumb">
                        <div class="image-container">
                            <img style="width:100%" src="assets/images/home/appprotecttlite_home.webp"
                                alt="Best Mobile Network & Application Data Security App" />
                        </div>
                    </div>


                </div>

                <div class="col-md-6">

                    <div class="row align-items-center h-100">
                        <div class="col mt-3">
                            <h3><span class="textred" style="font-size: 26px;">App</span><span class="textblue"
                                    style="font-size: 26px;">Protectt Lite</span></h3>
                            <div class="image-container-mobile text-center mt-3">
                                <img style="width:100%" src="assets/images/home/appprotecttlite_home.webp"
                                    alt="Secure your Mobile Apps with All in One Mobile App Security " />
                            </div>
                            <p class="text-justify">Lightweight & easy to configure Mobile App Security for FinTechs, &
                                Startups.
                                <br><br>AppProtectt Lite is SDK enabled, Plug & Play solution for enhanced Mobile App
                                Security which offers 20+ Mobile In-App Security features such as reverse engineering &
                                app tampering, unsecured Wi-Fi security check, protection from screen mirroring and
                                sharing, malware protection, and more.
                            </p>
                            <p class="mobile-view"><a routerLink="/appprotectt-lite" class="btn btn-primary">Read
                                    More</a></p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
    
    <div class="container mt-30 mb-30">
        <div class="row">
            <div class="col-md-12 img_body">

                <div class="overlay">
                    <h1>To get Complimentary Mobile App Security Assessment</h1>
                    <!-- <p class="mt-30"><a routerLink="/appprotectt-lite" class="btn btn-primary">Request a Demo
                        </a></p> -->

                    <a data-toggle="modal" data-target="#modalContactForm"
                        class="btn contact-btn btn-rectengle text-white mb-10">Request a Demo</a>
                    <ul style="padding-left: 20px;" class="pointers mt-10">
                        <li>Enhance your Mobile App Security Effortlessly</li>
                        <li>Specialise in Mobile Threat Defence</li>
                        <li>Secure your Brand Reputation</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
    <section class="awardandrecognition backcolor0  mt-40 pb-5">
        <div class="container">
            <div class="row">
                <div class="col-md-12 section-title text-center mt-30">
                    <h4>Next Generation RASP Mobile App Security<br>For Digital First Economy</h4>
                    <h5 class="mt-20 text-center" style="font-size: 1.8rem">Watch A Video</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <div class="text-center">
                        <a href="javascript://" class="mainvideoimage" data-toggle="modal" data-target="#playVideoHome"
                            (click)="onClickPdfView('video/Protectt Ai (19 May 2023).m4v','video')">
                            <img src="../../../assets/images/home/video_cover.webp" alt="video" width="100%" height="auto"
                                title="Home Video">
                        </a>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>

        <div class="needformobile">
            <div class="container mrgtop-thirty">
                <div class="row text-center why-choose-container">
                    <div class="col-md-12 section-title mt-20 mb-10">
                        <h4 class="text-white">Mobile App Security A Need of Digital Era</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 text-white mrgbtm-fourty">
                        <h4 class="text-white needforheadhing mrgtop-fifty">Shocking 845% Growth in Mobile Cyber
                            Attacks in India</h4>
                        <p>Between October 2020 and March 2021, India witnessed a shocking and scary 845% growth
                            in
                            cyber attacks exclusively on mobile devices</p>
                        <h4 class="text-white needforheadhing mrgtop-fifty">Mobile Apps are the New Gateway to Cyber
                            Hacks</h4>
                        <p>Our internal independent study on the state of BFSI Mobile Applications Security
                            revealed
                            that 95% of mobile apps are susceptible to reverse engineering</p>
                        <h4 class="text-white needforheadhing mrgtop-fifty">Trust, Reputation and Regulatory
                            Compliance
                        </h4>
                        <p>Whether you are developing an innovative consumer app or an enterprise app for your
                            employees, end-users trust organizations to secure the valuable data that they share
                        </p>
                    </div>
                    <div class="col-md-6 mrgbtm-fourty mrgtop-ninty">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="iconlist">
                                    <li><a id="one"></a></li>
                                    <li><a id="two"></a></li>
                                    <li><a id="three"></a></li>
                                    <li><a id="four"></a></li>
                                </ul>
                                <ul class="iconlist">
                                    <li><a id="five"></a></li>
                                    <li><a id="six"></a></li>
                                    <li><a id="seven"></a></li>
                                    <li><a id="eight"></a></li>
                                </ul>
                                <ul class="iconlist">
                                    <li><a id="nine"></a></li>
                                    <li><a id="ten"></a></li>
                                    <li><a id="eleven"></a></li>
                                    <li><a id="twelve"></a></li>
                                </ul>
                                <ul class="iconlist">
                                    <li><a id="thirteen"></a></li>
                                    <li><a id="fourteen"></a></li>
                                    <li><a id="fifteen"></a></li>
                                    <li><a id="sixteen"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <!-- Why Choose Protectt.ai? -->
    <div class="container-fluid" style="overflow-x: hidden;">


        <!-- <div class="container"> -->
        <div class="row mt-20">
            <div class="col-md-12 section-title">
                <h4 class="text-center mt-20">Why Choose Protectt.ai?</h4>
            </div>
        </div>
        <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item text-center pl-4" style="width: 100%;">

                <img class="img-fluid" src="assets/images/new/icon_1.webp" alt="Real-Time,Always-On Security">
                <h3 class="text-center mt-10">50+ Mobile App Security Features</h3>

            </li>
            <li class="list-group-item text-center" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_2.webp" alt="Secure Your Organization's Productivity">
                <h3 class="text-center mt-10 pb-3">Protection Against Cyber Threats</h3>
            </li>
            <li class="list-group-item text-center" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_3.webp" alt="Protect the Personal and Professional You">
                <h3 class="text-center mt-10 pb-3">Run Time Mobile Security</h3>
            </li>
            <li class="list-group-item text-center" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_4.webp" alt="Specialized Cyber Security Consulation">
                <h3 class="text-center mt-10 pb-3">Enforcement Device/Network Policy</h3>
            </li>
            <li class="list-group-item text-center" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_5.webp" alt="Fraud and Risk Mitigation">
                <h3 class="text-center mt-10 pb-3">Global Regulatory Compliances</h3>
            </li>
            <li class="list-group-item text-center" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_6.webp" alt="Secure your Brand Reputation">
                <h3 class="text-center mt-10 pb-3">Secure your Brand Reputation</h3>
            </li>
            <li class="list-group-item text-center pr-4" style="width: 100%;">
                <img class="img-fluid" src="assets/images/new/icon_6.webp" alt="Secure your Brand Reputation">
                <h3 class="text-center mt-10 pb-3">Fraud Control & Live Threat Monitoring</h3>
            </li>

        </ul>
        <div class="prestigiouscustomers">
            <div class="container-fluid mt-40">
                <div class="row">
                    <div class="col-md-12 text-center section-title mt-20">
                        <h4>Few of Our Prestigious Customers</h4>
                    </div>
                </div>
                <div class="section-pt section-pb-30" style="padding-top: 0px; padding-bottom: 50px;">
                    <div class="col-lg-12 p-0">
                        <div class="marquee-wrapper m-0">

                            <div class="marquee-block">
                                <div class="marquee-inner to-left">

                                    <span>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/bsemain.webp" width="170" height="92"
                                                alt="BSE Experience The New">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/RBL_Bank.webp" width="170" height="92"
                                                alt="RBL Bank">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/Yes_Bank_logo.webp" width="170" height="92"
                                                alt="YES Bank">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/fincare.webp" width="170" height="92"
                                                alt="Fincare">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/Chola-MS.webp" width="170" height="92"
                                                alt="Chola MS">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_home.webp" width="170" height="92"
                                                alt="IIFL Home Loan">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_security.webp" width="170" height="92"
                                                alt="IIFL Securities">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/suryoday_logo.webp" width="170" height="92"
                                                alt="SURYODAY">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/fusion_logo.webp" width="170" height="92"
                                                alt="FUSION">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/pharmatica.webp" width="170" height="92"
                                                alt="PRAMERICA">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/ageas_fedral.webp" width="170" height="92"
                                                alt="ageasFEDERAL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/equitas_logo.webp" width="170" height="92"
                                                alt="Equitas">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_finance.webp" width="170" height="92"
                                                alt="IIFL Finance">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/india_icc.webp" width="170" height="92"
                                                alt="INDIA ICC">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/india_inx.webp" width="170" height="92"
                                                alt="INDIA INX">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/kinara.webp" width="170" height="92"
                                                alt="KINARA CAPITAL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/midgate.webp" width="170" height="92"
                                                alt="MINDGATE">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iccl.webp" width="170" height="92" alt="ICCL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/5paisa.webp" width="170" height="92"
                                                alt="5Paisa.com">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/ed_prime.webp" width="170" height="92"
                                                alt="ED PRIME">
                                        </div>
                                    </span>
                                    <span>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/bsemain.webp" alt="BSE Experience The New">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/RBL_Bank.webp" alt="RBL Bank">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/Yes_Bank_logo.webp" alt="YES Bank">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/fincare.webp" alt="Fincare">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/Chola-MS.webp" alt="Chola MS">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_home.webp" alt="IIFL Home Loan">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_security.webp" alt="IIFL Securities">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/suryoday_logo.webp" alt="SURYODAY">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/fusion_logo.webp" alt="FUSION">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/pharmatica.webp" alt="PRAMERICA">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/ageas_fedral.webp" alt="ageasFEDERAL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/equitas_logo.webp" alt="Equitas">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iifl_finance.webp" alt="IIFL Finance">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/india_icc.webp" alt="INDIA ICC">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/india_inx.webp" alt="INDIA INX">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/kinara.webp" alt="KINARA CAPITAL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/midgate.webp" alt="MINDGATE">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/iccl.webp" alt="ICCL">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/5paisa.webp" alt="5Paisa.com">
                                        </div>
                                        <div class="marquee-item">
                                            <img src="assets/images/new/ed_prime.webp" alt="ED PRIME">
                                        </div>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 section-title text-center mb-10 mt-10">
                        <h4>What Customers Are Saying About Us?</h4>
                    </div>
                </div>
                <!-- <app-what-customers></app-what-customers> -->
                <app-about-protecttai></app-about-protecttai>
            </div>


        </section>
        <section class="awardandrecognition backcolor0">
            <div class="container-fluid">
                <div class="row mt-30">
                    <div class="col-md-12 col-sm-12 col-xs-12 section-title text-center mb-25">
                        <h4 class="mrgn">Awards & Recognition</h4>
                    </div>
                </div>
                <div class="col-lg-12 p-0">
                    <app-awardsandrecognition></app-awardsandrecognition>
                </div>

            </div>


        </section>
        <section>
            <div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-xs-12 col-sm-12 text-center section-title">
                            <h4>Blogs</h4>
                        </div>
                    </div>
                    <div class="row">
                        <app-home-blogs></app-home-blogs>
                    </div>
                </div>
                <!-- <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-xs-12 col-sm-12 text-center section-title">
                            <h4>Blogs</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">
                                <h5 class="card-title blog-title-change text-center">Protecting Sensitive Mobile Apps on
                                    Rooted
                                    Devices</h5>
                            </a>
                        </div>
                        <div class="col-md-4">
                            <a routerLink="/rasp-in-era-of-devsecops">
                                <h5 class="card-title blog-title-change text-center">Runtime Application Self-Protection
                                    (RASP)
                                    for
                                    Mobile App Security in the Era of DevSecOps</h5>
                            </a>
                        </div>
                        <div class="col-md-4">
                            <a routerLink="/risk_and_impacts_of_accessibility_permission">
                                <h5 class="card-title blog-title-change text-center">The Risk and Impact of Accessibility
                                    Permission
                                    on Mobile Apps</h5>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card bg-transparent border-0">
                                <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">
                                    <img src="assets/images/blog/rooted_devices.webp" class="card-img-top"
                                        alt="Protecting Sensitive Mobile Apps on Rooted Devices">
                                </a>
                                <div class="card-body text-center">
                                    <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device"
                                        class="btn btn-primary">Read
                                        More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card bg-transparent border-0">
                                <a routerLink="/rasp-in-era-of-devsecops">
                                    <img src="assets/images/blog/devsecops.webp" class="card-img-top"
                                        alt="Runtime Application Self-Protection (RASP) for Mobile App Security in the Era of DevSecOps">
                                </a>
                                <div class="card-body text-center">
                                    <a routerLink="/rasp-in-era-of-devsecops" class="btn btn-primary">Read More</a>
                                </div>
                            </div>
                        </div>
    
                        <div class="col-md-4">
                            <div class="card bg-transparent border-0">
                                <a routerLink="/risk_and_impacts_of_accessibility_permission">
                                    <img src="assets/images/blog/accessibility_permission.webp" class="card-img-top"
                                        alt="The Risk and Impact of Accessibility Permission on Mobile Apps">
                                </a>
                                <div class="card-body text-center">
                                    <a routerLink="/risk_and_impacts_of_accessibility_permission"
                                        class="btn btn-primary">Read
                                        More</a>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div> -->
            </div>
        </section>

        <section style="margin-top: 0px;" class="mediasection backcolor1 pt-5">
            <div class="curve">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 section-title text-center">
                        <h4>Media</h4>
                    </div>
                </div>
                <div class="row bgcolor">
                    <div class="col-12 col-lg-6 newscard">
                        <a href="https://www.financialexpress.com/business/blockchain-protectt-ai-launches-a-new-version-of-appprotectt-3207860/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/financial.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Protectt.ai launches a new version of AppProtectt </h6>
                                    <!-- <p class="newsdate">sep 20, 2022</p> -->
                                    <p>According to an official release, Protectt.ai, a mobile threat defence and
                                        cybersecurity company, launched a new version of AppProtectt, a mobile app
                                        security platform (XDR)</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard">
                        <a href="https://timesofindia.indiatimes.com/blogs/voices/building-digital-identity-of-mobile-users-a-must-for-banking-and-financial-organisations/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/times_of_india.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Building digital identity of mobile users, a must for banking and financial
                                        organisations
                                    </h6>
                                    <!-- <p class="newsdate">sep 8, 2022</p> -->
                                    <p>As we shift rapidly towards a digitized world, financial activities are getting
                                        revolutionized. With the current rise of online
                                        frauds and cybercrimes, securing Digital Identity has become more important than
                                        ever.</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://yourstory.com/2023/08/how-mumbai-based-protecttai-uses-deep-tech-protect-digital-assets"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/your_story.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>How Mumbai-based Protectt.ai uses deep-tech to protect digital assets from cyber
                                        threats</h6>
                                    <!-- <p class="newsdate">sep 8, 2022</p> -->
                                    <p>In recent years, India has witnessed rapid digitisation, with almost 750 million
                                        smartphone users, with internet connectivity spreading far and wide to remote
                                        corners of the country.</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://businessindia.co/magazine/protecttai-unveils-plans-to-fight-mobile-frauds-and-cyber-threats"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/business_india.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Protectt.ai unveils plans to fight mobile frauds and cyber threats</h6>
                                    <!-- <p class="newsdate">sep 19, 2022</p> -->
                                    <p>Manish Mimani is a man on a mission. On the eve of Republic Day 2023, Mimani is
                                        unveiling his latest initiative, ‘Protectech’. </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://www.financialexpress.com/industry/technology/protectt-ai-keeping-your-mobile-data-secure-from-cyberthreats/2672717/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/financial.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent medianewsheading">
                                    <h6>Protectt.ai: Keeping Your Mobile Data Secure From Cyberthreats</h6>
                                    <!-- <p class="newsdate">sep 19, 2022</p> -->
                                    <p>Protectt.ai has developed a plug-and-play security component which can be
                                        integrated
                                        with mobile apps and by default it</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://timesofindia.indiatimes.com/blogs/voices/seven-steps-towards-safe-secured-banking-app-usage/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/times_of_india.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Seven Steps Towards Safe & Secured Banking App Usage</h6>
                                    <!-- <p class="newsdate">sep 7, 2022</p> -->
                                    <p>Manish Mimani, Founder and CEO of Protectt.ai, shares important insights about
                                        “Seven
                                        steps towards safe & secured banking app usage”</p>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://www.expresscomputer.in/guest-blogs/securing-digital-india-must-extend-to-mobile-devices/89820/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/express.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Securing Digital India Must Extend to Mobile Devices</h6>
                                    <p>India’s ambitious objective of reaching the US$1 trillion digital economy must be
                                        carefully nurtured with a strong foundation of trust</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 newscard mt-35">
                        <a href="https://www.mobilityindia.com/protectt-ais-mobile-app-security-platform-appprotectt-recognized-as-winner-of-banking-frontier-technoviti-award-2023/"
                            target="_blank">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 text-center">
                                    <img class="newslogo" src="../../../assets/images/medianews/mobility.webp"
                                        alt="News Logo">
                                </div>
                                <div class="col-lg-8 col-md-8 newscontent">
                                    <h6>Protectt.ai’s Mobile App Security Platform “AppProtectt” Recognized as winner of
                                        Banking Frontier Technoviti Award, 2023
                                    </h6>
                                    <p>Protectt.ai is proud to announce that its flagship Mobile App Security platform
                                        “AppProtectt” has been chosen as the winner of the Technoviti Award, 2023.</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>


                <div class="row mt-30">
                    <div class="col-md-12 text-center mb-30">
                        <h4><a routerLink="/media">More News &#8594;</a></h4>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="container-fluid">
        <div class="careers">
            <div class="container pt-4">
                <div class="row">
                    <div class="col-md-12 text-center section-title mb-0">
                        <h4>Careers</h4>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-md-4">
                        <div class="text-center">
                            <img class="imgpadding" src="assets/images/new/careers.webp" alt="Careers">
                        </div>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-7 carrercontent">
                        <span class="join-us-txt">Join us Today!!</span>
                        <p>Be a young and dynamic protecttor, with an enthusiastic team determined to accomplish the
                            vision of becoming a mobile app security expert.</p>
                        <span class="our-core-value">Our core Values</span><br>
                        <span class="our-core-valuetag">Innovation | Trust | Mutual Respect | Growth</span><br>
                        <a class="btn-rectangle btn mt-4" routerLink="/careers">Apply
                            Now</a>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="blogs">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-xs-12 col-sm-12 text-center section-title">
                        <h4>Blogs</h4>
                    </div>
                </div>
                <div class="row">
                    <app-home-blogs></app-home-blogs>
                </div>
            </div>

        </div> -->

    </div>

    <!-- Inner Section OR Extra Content -->

    <div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div style="background: #163e6f" class="p-2">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                        #closebutton>
                        <span style="color: #fff" aria-hidden="true">&times;</span>
                    </button>
                    <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                        Contact Us
                    </h4>
                    <h6 style="color: #fff">Get ready to enhance your Mobile App Security effortlessly</h6>
                </div>
                <!-- <div style="display: block" class="modal-header text-center">
                    <p class="formparagraph1">Protectt.ai Labs cherish your excellent decision Talk to Protectt.ai Labs
                        to
                        learn more about how we can secure your mobile app and its data, by filling out the form below.
                        For
                        product support, please visit our·contact sales page.
                    </p>
                </div> -->
                <div class="modal-body mx-3">
                    <form [formGroup]="demoForm" class="contactusform">
                        <div class="row">

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
                                <input type="text" placeholder="Enter Your Name" id="form34"
                                    class="form-control validate input" formControlName="name" name="name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                    <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Work
                                    Email*</label>
                                <input type="email" placeholder="Enter Your Email " formControlName="email"
                                    class="form-control input" id="email" name="email"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                    <div *ngIf="getDemoForm.email.errors.isValidEmail">* Please enter business email
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                    Number*</label>
                                <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                    class="form-control validate input" formControlName="contactnumber"
                                    name="contactnumber"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                    </div>
                                    <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                        Mobile
                                        Number.
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="form34">Company*</label>
                                <input type="text" placeholder="Enter Your Company Name" id="form34"
                                    class="form-control validate input" formControlName="company_name"
                                    name="company_name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="form34">Designation*</label>
                                <input type="text" placeholder="Enter Your Designation" id="form34"
                                    class="form-control validate input" formControlName="designation" name="designation"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name
                                    </div>
                                </div>
                            </div>
                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                    Slot
                                    1*</label>
                                <input type="datetime-local" id="form34" class="form-control validate input"
                                    formControlName="time_slot1" name="time_slot1"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="row">
                            <div class="md-form mb-20 col-md-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                    Slot
                                    1*</label>
                                <input type="datetime-local" id="form34" class="form-control validate input"
                                    formControlName="time_slot1" name="time_slot1"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                                </div>
                            </div>
                            <div class="md-form mb-20 col-md-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                    Slot
                                    2*</label>
                                <input type="datetime-local" id="form34" class="form-control validate input"
                                    formControlName="time_slot2" name="time_slot2"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
                                </div>
                            </div>
                        </div> -->
                        <div class="md-form">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
                                you?</label>
                            <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
                                class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                            <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                                (click)="onReset()">
                                Cancel
                            </button>
                            <!-- <button class="btn btn-secondary" type="reset" (click)="onReset()">Cancel</button> -->
                        </div>
                    </form>
                    <!-- <p style="color: #000">{{ message }}</p> -->
                </div>
            </div>
        </div>
    </div>

    <!-- factsheet modal -->

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        Check Our Product Factsheets
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="content text-center">
                        <!-- <div class="row"> -->
                        <!-- <h6>App Protectt Datasheet</h6> -->
                        <!-- <a href="assets/data/App-Protectt-Datasheet.pdf" target="_blank"
                        class="btn contact-btn mt-30 btn-circle">App
                        Protectt Datasheet</a> -->
                        <a style="color: #fff" class="btn contact-btn mt-30 btn-rectengle"
                            (click)="onClickPdfView('App-Protectt-Datasheet.pdf', 'pdf')">App
                            Protectt Datasheet</a>
                        <!-- <a href="assets/data/Mobile-Protect-Enterprise-Datasheet.pdf" target="_blank"
                        class="btn contact-btn mt-30 btn-circle">MProtectt Enterprise Datasheet</a> -->
                        <a style="color: #fff" class="btn contact-btn mt-30 btn-rectengle"
                            (click)="onClickPdfView('Mobile-Protect-Enterprise-Datasheet.pdf', 'pdf')">MProtectt
                            Enterprise
                            Datasheet</a>
                        <!-- <a href="assets/data/Real-Time-Protectt-Datasheet.pdf" target="_blank"
                        class="btn contact-btn mt-30 btn-circle">RealTime Protectt Datasheet</a> -->
                        <a style="color: #fff" class="btn contact-btn mt-30 btn-rectengle"
                            (click)="onClickPdfView('Real-Time-Protectt-Datasheet.pdf', 'pdf')">RealTime Protectt
                            Datasheet</a>
                        <!-- </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="mediaimagepopup" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true">
        <div class="modal-dialog text-center" role="document">
            <!-- <div class="modal-content"> -->
            <img class="imp-bg" src="assets/images/aug05img.jpg" alt="Protectt.ai expands reach">
            <!-- </div> -->
        </div>
    </div>

</main>


<div class="modal fade" id="playVideoHome" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1"
    aria-hidden="true">
    <div class="modal-dialog modal-md w-98vh" role="document">
        <div class="modal-content m-0 p-0 h-98vh position-relative">
            <button type="button" class="btn position-top-right" data-dismiss="modal" aria-label="Close">
                <span style="color: #fff" aria-hidden="true">X</span>
            </button>
            <iframe id="videospeak" [src]="videoUrl" width="100%" height="100%" frameborder="0" allowtransparency="true"
                webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay">
            </iframe>
        </div>
    </div>
</div>